function docReady(fn) {
    document.readyState === "complete" || document.readyState === "interactive" ? setTimeout(fn, 1) : document.addEventListener("DOMContentLoaded", fn)
}
docReady(setWizzyCustomPlaceHolder);
function setWizzyCustomPlaceHolder() {
    let desktop, mobile_1, mobile_2;
    const phrases = ["Wheat Berries", "Kamut", "Rice", "Oats", "Flour"];

    if(document.documentElement.clientWidth >= 768) {
      desktop = document.querySelector('header input[name="q"]');
      desktop.placeholder = "Search for ";
    }

    if(document.documentElement.clientWidth < 768) {
      mobile_2 = document.querySelector('nav input[name="q"]');
      mobile_2.placeholder = "Search for ";
    }
  
    let index = 0, typingTimer;
    const typePhrase = function(placeholderText) {
        const phrase = phrases[index]
          , len = phrase.length;
        let i = 0;
        typingTimer = setInterval(function() {
            if (i === len)
                clearInterval(typingTimer),
                setTimeout(function() {
                    erasePhrase(placeholderText)
                }, 1e3);
            else {
                const currentText = placeholderText.getAttribute("placeholder");
                placeholderText.placeholder = currentText + phrase.charAt(i),
                i++
            }
        }, 100)
    }
      , erasePhrase = function(placeholderText) {
        const currentText = placeholderText.getAttribute("placeholder")
          , len = currentText.length;
        let i = len - 1;
        typingTimer = setInterval(function() {
            if (i === 10)
                clearInterval(typingTimer),
                index++,
                index === phrases.length && (index = 0),
                setTimeout(function() {
                    typePhrase(placeholderText)
                }, 1e3);
            else {
                const newText = currentText.slice(0, i);
                placeholderText.setAttribute("placeholder", newText),
                i--
            }
        }, 100)
    };
    document.documentElement.clientWidth < 768 ? mobile_2 && typePhrase(mobile_2) : desktop && typePhrase(desktop)
}